import React, { useEffect, useState } from 'react';
import PropType from 'prop-types';
import { Select } from 'antd';
import { AppConstants } from '../../core/app.constants';
import CustomModal from '../Modal';
import { useTranslation } from 'react-i18next';
import { WarningTwoTone } from '@ant-design/icons';
import { isUK, translationWrapper } from 'utils/common-methods';
import ReactCountryFlag from "react-country-flag";
import './styles.less';

const ChangeLocationModal: React.FC<ChangeLocationModalProps> = (
  {
  isModalOpen,
  onChange,
  userCountry,
  setIsModalOpen,
  setUserCountry,
  value,
  emptyCountry,
  },
  ) => {
  const { t } = translationWrapper(useTranslation());
  return (
    <CustomModal
        className={'change-location-container'}
        content={
          // tslint:disable-next-line:jsx-wrap-multiline
          <div id={'changeLocationModalBody'}>
            <p id={'changeLocationModalTitle'}>
              {t('heading.change_location_of_residence')}{' '}
            </p>
            <p id={'changeLocationModalMessage'}>
              {t(`${isUK() ? 'description.after_changing_your_location_we_will_need_you_to_review_syngenta_digital' : 'description.after_changing_your_location_we_will_need_you_to_review_cropwise' }`)}
            </p>
          </div>
        }
        icon={
          // tslint:disable
          <WarningTwoTone
              twoToneColor="#E99921"
              style={{ fontSize: "20px" }}
          />
          // tslint:enable
        }
        title={''}
        visible={isModalOpen}
        okButton={{
          text: t('global.button.ok'),
          onContinue: () => {
            onChange?.(userCountry);
            setIsModalOpen(false);
          },
        }}
        cancelButton={{
          text: t('global.button.cancel'),
          onCancel: () => {
            setUserCountry(value ? value : emptyCountry);
            setIsModalOpen(false);
          },
        }}
    />
  );
};

interface ChangeLocationModalProps {
  isModalOpen?: any;
  onChange?: (value: any) => void;
  userCountry?: string;
  setIsModalOpen?: any;
  setUserCountry?: any;
  value?: string;
  emptyCountry?: string;
}
function CountryDropdown(props: {
  value?: string;
  onChange?: (value: any) => void;
  currentUser?: any
}) {
  const emptyCountry = '';
  const [userCountry, setUserCountry] = useState(props.value);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setUserCountry(props.value);
  },[props.value]);

  const onSelectedCountry = (country: string) => {
    setUserCountry(country);
    if (country && props.value !== country) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  };

  return (
      <div id={'changeLocationDiv'}>
        <Select value={userCountry} dropdownClassName="edit-profile-dropdown-container" data-testid={'selectedCountryDropdown'} onSelect={onSelectedCountry}>
          {AppConstants?.SUPPORTED_COUNTRIES?.map((country) => {
            return (
                <Select.Option id={'country-dropdown-' + country.value} key={country.value} value={country.value} className="country-dropdown-input-box">
                   <span><ReactCountryFlag countryCode={country.value} svg/></span>
                   <span>{country.name}</span>
                </Select.Option>
            );
          })}
        </Select>
        <ChangeLocationModal isModalOpen={isModalOpen} onChange={props.onChange} userCountry={userCountry} setIsModalOpen={setIsModalOpen} setUserCountry={setUserCountry} value={props.value} emptyCountry={emptyCountry} />
      </div>
  );
}

CountryDropdown.propTypes = {
  value: PropType.string,
  onChange: PropType.func
};
export default CountryDropdown;
